import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BagContext = createContext(null);

export const BagProvider = ({ children }) => {
  const [quantity, setQuantity] = useState(0);
  const [open, setOpen] = useState(false);

  // Restore the bag from a previously saved Shopify cart (read-only; never creates a cart).
  useEffect(() => {
    const cartId = localStorage.getItem("shopify_cart_id");
    if (!cartId) return;
    axios
      .get(`${API}/shopify/cart`, { params: { cart_id: cartId } })
      .then((res) => {
        const restored = res.data?.quantity || 0;
        if (restored > 0) setQuantity(restored);
      })
      .catch(() => {
        // Expired or invalid cart: clear the stored ID and keep the bag empty.
        localStorage.removeItem("shopify_cart_id");
      });
  }, []);

  const addToBag = useCallback((qty = 1) => {
    setQuantity((q) => q + qty);
    setOpen(true);
  }, []);

  const value = useMemo(
    () => ({ quantity, setQuantity, open, setOpen, addToBag }),
    [quantity, open, addToBag]
  );

  return (
    <BagContext.Provider value={value}>
      {children}
    </BagContext.Provider>
  );
};

export const useBag = () => useContext(BagContext);
